module.exports = __webpack_public_path__ + "831c35186e6998a12f874a0af50f2aeb.MP3";